import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const VoyahCourageSpecSectionEditor = () => {
  const [form, setForm] = useState({
    topTitleEn: "",
    topTitleAr: "",
    topTitleKu: "",
    topParagraphEn: "",
    topParagraphAr: "",
    topParagraphKu: "",
    btn1En: "",
    btn1Ar: "",
    btn1Ku: "",
    btn2En: "",
    btn2Ar: "",
    btn2Ku: "",
    card1TitleEn: "",
    card1TitleAr: "",
    card1TitleKu: "",
    card1TextEn: "",
    card1TextAr: "",
    card1TextKu: "",
    card2TitleEn: "",
    card2TitleAr: "",
    card2TitleKu: "",
    card2TextEn: "",
    card2TextAr: "",
    card2TextKu: "",
  });

  const [images, setImages] = useState({
    top: null,
    card1: null,
    card2: null,
  });

  const [loading, setLoading] = useState(true);

  // Modal State
  const [showModal, setShowModal] = useState(false);
  const [modalTarget, setModalTarget] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);

  const resolveUrl = (u) =>
    u?.startsWith("http") ? u : `${API_BASE}${u}`;

  // ========================================================
  // LOAD DATA (3 LANGUAGES)
  // ========================================================
  useEffect(() => {
    const loadData = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/specs/VoyahCourageSpecs?lang=en`),
          axios.get(`${API_BASE}/api/specs/VoyahCourageSpecs?lang=ar`),
          axios.get(`${API_BASE}/api/specs/VoyahCourageSpecs?lang=ku`),
        ]);

        // TEXTS
        setForm({
          topTitleEn: en.data.top.title,
          topParagraphEn: en.data.top.paragraph,
          btn1En: en.data.top.button1,
          btn2En: en.data.top.button2,
          card1TitleEn: en.data.card1.title,
          card1TextEn: en.data.card1.text,
          card2TitleEn: en.data.card2.title,
          card2TextEn: en.data.card2.text,

          topTitleAr: ar.data.top.title,
          topParagraphAr: ar.data.top.paragraph,
          btn1Ar: ar.data.top.button1,
          btn2Ar: ar.data.top.button2,
          card1TitleAr: ar.data.card1.title,
          card1TextAr: ar.data.card1.text,
          card2TitleAr: ar.data.card2.title,
          card2TextAr: ar.data.card2.text,

          topTitleKu: ku.data.top.title,
          topParagraphKu: ku.data.top.paragraph,
          btn1Ku: ku.data.top.button1,
          btn2Ku: ku.data.top.button2,
          card1TitleKu: ku.data.card1.title,
          card1TextKu: ku.data.card1.text,
          card2TitleKu: ku.data.card2.title,
          card2TextKu: ku.data.card2.text,
        });

        // IMAGES
        setImages({
          top: en.data.top.image,
          card1: en.data.card1.image,
          card2: en.data.card2.image,
        });

        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };

    loadData();
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ========================================================
  // SAVE TEXTS
  // ========================================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/specs/VoyahCourageSpecs`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Texts Saved!");
    } catch (err) {
      console.error(err);
      alert("Failed to save texts.");
    }
  };

  // ========================================================
  // DELETE IMAGE
  // ========================================================
  const handleDeleteImage = async (section) => {
    const token = localStorage.getItem("token");

    if (!images[section]) return alert("No image to delete.");

    try {
      await axios.delete(`${API_BASE}/api/specs/VoyahCourageSpecs/image`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { url: images[section], section },
      });

      alert("Image deleted!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Failed to delete.");
    }
  };

  // ========================================================
  // UPLOAD IMAGE  (PUT -> media)
  // ========================================================
  const handleUploadImage = async () => {
    if (!uploadFile) return alert("Select a file first.");

    const token = localStorage.getItem("token");
    const fd = new FormData();

    if (modalTarget === "top") {
      fd.append("TopImage", uploadFile);
    }
    if (modalTarget === "card1") {
      fd.append("Card1Image", uploadFile);
    }
    if (modalTarget === "card2") {
      fd.append("Card2Image", uploadFile);
    }

    try {
      await axios.put(`${API_BASE}/api/specs/VoyahCourageSpecs/media`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Image updated!");
      setShowModal(false);
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  if (loading) return <p>Loading...</p>;

  const LANGS = ["En", "Ar", "Ku"];

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Voyah Courage – Specs Editor</h2>

      {/* ========================================================
          TEXT (3 LANGUAGES)
      ======================================================== */}
      <div className="row">
        {LANGS.map((lang) => (
          <div className="col-lg-4 col-md-6 mb-4" key={lang}>
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body">
                <h5 className="text-primary mb-3">{lang}</h5>

                <label className="form-label">Top Title</label>
                <input
                  className="form-control mb-2"
                  name={`topTitle${lang}`}
                  value={form[`topTitle${lang}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Top Paragraph</label>
                <textarea
                  className="form-control mb-2"
                  name={`topParagraph${lang}`}
                  value={form[`topParagraph${lang}`]}
                  rows={3}
                  onChange={handleChange}
                />

                <label className="form-label">Button 1</label>
                <input
                  className="form-control mb-2"
                  name={`btn1${lang}`}
                  value={form[`btn1${lang}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Button 2</label>
                <input
                  className="form-control mb-3"
                  name={`btn2${lang}`}
                  value={form[`btn2${lang}`]}
                  onChange={handleChange}
                />

                <h6 className="mt-3">Card 1</h6>

                <label className="form-label">Title</label>
                <input
                  className="form-control mb-2"
                  name={`card1Title${lang}`}
                  value={form[`card1Title${lang}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Text</label>
                <textarea
                  className="form-control mb-2"
                  name={`card1Text${lang}`}
                  rows={3}
                  value={form[`card1Text${lang}`]}
                  onChange={handleChange}
                />

                <h6 className="mt-3">Card 2</h6>

                <label className="form-label">Title</label>
                <input
                  className="form-control mb-2"
                  name={`card2Title${lang}`}
                  value={form[`card2Title${lang}`]}
                  onChange={handleChange}
                />

                <label className="form-label">Text</label>
                <textarea
                  className="form-control"
                  name={`card2Text${lang}`}
                  rows={3}
                  value={form[`card2Text${lang}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE BUTTON */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-4" onClick={handleSave}>
          Save Changes
        </button>
      </div>

      {/* ========================================================
           IMAGE BLOCKS
      ======================================================== */}
      <h4 className="mb-3">Images</h4>

      {["top", "card1", "card2"].map((imgKey) => (
        <div className="card border-0 shadow-sm mb-4" key={imgKey}>
          <div className="card-body">
            <h5 className="mb-3 text-capitalize">{imgKey} Image</h5>

            {images[imgKey] ? (
              <img
                src={resolveUrl(images[imgKey])}
                className="w-100 rounded mb-3"
                style={{ maxHeight: "260px", objectFit: "cover" }}
                alt=""
              />
            ) : (
              <p>No image uploaded</p>
            )}

            <div className="d-flex gap-2">
              <button
                className="btn btn-danger"
                disabled={!images[imgKey]}
                onClick={() => handleDeleteImage(imgKey)}
              >
                Delete
              </button>

              <button
                className="btn btn-primary"
                onClick={() => {
                  setShowModal(true);
                  setModalTarget(imgKey);
                }}
              >
                Upload / Replace
              </button>
            </div>
          </div>
        </div>
      ))}

      {/* ========================================================
          MODAL
      ======================================================== */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Image ({modalTarget})</h5>
                  <button className="btn-close" onClick={() => setShowModal(false)} />
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>

                  <button className="btn btn-primary" onClick={handleUploadImage}>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show" />
        </>
      )}
    </div>
  );
};

export default VoyahCourageSpecSectionEditor;
